import { Copyable, Steps as SharedSteps, Step } from '@components'

import { useTranslation } from 'react-i18next'

const AGERAS_CVR = 33239106

export const Steps = () => {
  const { t } = useTranslation()

  const steps: Step[] = [
    {
      number: 1,
      description: 'skat_form.steps.select_nemvirksomhed_description',
      header: t('skat_form.steps.select_nemvirksomhed_header'),
    },
    {
      number: 2,
      description: 'skat_form.steps.enter_number_description',
      header: t('skat_form.steps.enter_number_header'),
      components: {
        copyable: (
          <Copyable valueToCopy={String(AGERAS_CVR)} renderAs="text" weight="bold">
            {AGERAS_CVR}
          </Copyable>
        ),
      },
    },
    {
      number: 3,
      description: 'skat_form.steps.confirm',
      header: t('skat_form.steps.confirm_header'),
    },
  ]

  return <SharedSteps steps={steps} />
}
